import {Component, OnInit} from '@angular/core';
import {GridOptions} from 'ag-grid';
import {ImportSettingsService} from './import-settings.service';

@Component({
  selector: 'app-import-settings',
  templateUrl: './import-settings.component.html',
  styleUrls: ['./import-settings.component.scss']
})
export class ImportSettingsComponent implements OnInit {

  protected showForm = false;
  columnDefs: any = [];
  rowData: any = [];
  protected gridImport: GridOptions;
  protected selectedRules: any;
  constructor( protected service: ImportSettingsService ) {
    this.gridImport = <GridOptions>{};
    this.gridImport.enableColResize = true;
    const self = this.gridImport;
    this.gridImport.columnDefs = this.columnsDefinitions();
    this.gridImport.onGridReady = function() {
      self.api.setGridAutoHeight(true);
    };
    this.getAllRules();
  }

  ngOnInit() { }

  columnsDefinitions() {
    return [
      { headerName: 'Title', field: 'description', colId: 'description', width: 100 },
      { headerName: 'Status', field: 'status', colId: 'status', width: 350 }
    ];
  }

  autoSizeAll() {
    const allColumnIds = [];
    this.gridImport.columnApi.getAllColumns().forEach(function(column) {
      allColumnIds.push(column['colId']);
    });
    this.gridImport.columnApi.autoSizeColumns(allColumnIds);
  }

  rowClick(data) {
    this.selectedRules = data.data;
    this.showForm = true;
  }

  getAllRules() {
    this.service.getAllRulesImports().subscribe(
        data => {
          this.loadData(data);
        }
      );
  }

  loadData(data) {
    this.gridImport.api.setRowData(data);
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/import-settings/import-settings.component.ts